import { Button } from "antd";
import FullPageLayout from "../../../../templates/FullPageLayout";
import { useEffect, useState } from "react";
import { NeedHelp } from "../../../../atoms/CustomIcons";
import AddServiceStep2 from "./AddServiceStep2";
import { useAppDispatch, useAppSelector } from "../../../../config/hooks";
import { getFrequencyForChild } from "../ducks/actions";

export default function AddSubService() {
  const dispatch = useAppDispatch();
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const serviceLineId = pathSegments[pathSegments.length - 2];
  const parentId = pathSegments[pathSegments.length - 3];
  const [loading, setLoading] = useState(false);
  const frequencyType = useAppSelector(
    (state) => state?.services?.frequencyType
  );

  useEffect(() => {
    if (parentId) {
      dispatch(getFrequencyForChild(parentId));
    }
  }, [parentId, dispatch]);

  return (
    <FullPageLayout loading={loading}>
      <Button className="btn-sm fixedTopBtn">
        <NeedHelp /> Need help?
      </Button>
      <div className="ServicesSteps">
        <AddServiceStep2
          setLoading={setLoading}
          companyId={companyId}
          serviceLineId={serviceLineId}
          parentId={parentId}
          type="simple"
          frequencyTypeData={frequencyType?.data}
        />
      </div>
    </FullPageLayout>
  );
}
